(() => {
  'use strict';
  if (customElements.get('nuve-bundle-picker')) return;

  const formatMoney = (cents) => {
    const format = (window.themeVariables && window.themeVariables.settings.moneyFormat) || '${{amount}}';
    const value = Math.round(Number(cents) || 0);
    const withDelims = (number, decimals, thousands, decimal) => {
      const fixed = (number / 100).toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? grouped + decimal + frac : grouped;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  };

  // Display-only bundle table: keeps the tier prices in sync with the selected variant.
  customElements.define('nuve-bundle-picker', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.options = Array.from(this.querySelectorAll('.nuve-bundle__option'));

      document.addEventListener('variant:change', (event) => {
        if (event.target?.getAttribute('id') !== this.dataset.formId) return;
        const variant = event.detail?.variant;
        if (variant) this.reprice(variant.price);
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    reprice(price) {
      this.dataset.price = price;
      this.options.forEach((o) => {
        const qty = parseInt(o.dataset.qty, 10) || 1;
        const pct = parseInt(o.dataset.pct, 10) || 0;
        const each = Math.floor(price * (100 - pct) / 100);
        const set = (sel, cents) => { const el = o.querySelector(sel); if (el) el.textContent = formatMoney(cents); };
        set('[data-each]', each);
        set('[data-total]', each * qty);
        set('[data-compare-total]', price * qty);
      });
    }
  });
})();
